import { BaseLink } from "@design-system/components/link";
import { cn } from "@design-system/lib/utils";
import { useBottomNavigation } from "../../hooks/use-bottom-navigation.hook";

export function BottomNavigation() {
  const { isMobile, items } = useBottomNavigation();

  if (!isMobile) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <div className="mx-auto flex max-w-xl items-center justify-around rounded-2xl border border-slate-200/80 bg-white/95 p-1.5 shadow-[0_-10px_36px_-18px_rgba(15,23,42,0.45)] backdrop-blur-xl dark:border-slate-700/80 dark:bg-slate-900/95">
        {items.map((item) => {
          const Icon = item.icon;
          const className = cn(
            "flex min-w-0 flex-1 flex-col items-center gap-1 rounded-xl px-2 py-2 text-[0.7rem] font-bold transition-all duration-200",
            "hover:bg-slate-100 dark:hover:bg-slate-800",
            item.isActive
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-slate-500 hover:text-slate-950 dark:text-slate-400 dark:hover:text-white",
          );

          if (item.onClick) {
            return (
              <button
                key={item.label}
                type="button"
                onClick={item.onClick}
                className={className}
                title={item.label}
              >
                <Icon className="h-5 w-5" />
                <span className="max-w-[60px] truncate">{item.label}</span>
              </button>
            );
          }

          return (
            <BaseLink
              key={item.to}
              to={item.to!}
              className={className}
              title={item.label}
            >
              <Icon
                className="h-5 w-5"
              />
              <span className="max-w-[60px] truncate">{item.label}</span>
            </BaseLink>
          );
        })}
      </div>
    </div>
  );
}
